import { styled } from "@mui/material/styles";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React from "react";
import Typography from "@mui/material/Typography";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import AccordionDetails from "@mui/material/AccordionDetails";

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `0px `,
  "&:not(:last-child)": {
    borderBottom: 0
  },
  "&:before": {
    display: "none"
  }
}));
const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ExpandMoreIcon />}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiAccordionSummary-content": {
    margin: 0
  }

}));


const items = [
  { header: "Review", text: "Our specialists review every aspect of your application to find errors or inconsistencies." },
  { header: "Prepare", text: "Your application will be prepared for submission to the USPTO by trained professionals." },
  { header: "Filing", text: "Your mark will be submitted to the USPTO electronic filing system by our trained team." },
  { header: "Email Delivery", text: "Official updates of your USPTO status are delivered to your via E-mail." },
  { header: "100% Money Back Guarantee", text: "If your mark cannot be filed with the USPTO, we will refund your money, no questions asked." },
  { header: "Trademark Monitoring", text: "1 Month of Free Trademark Monitoring included to ensure no infringements on your mark are filed." },
  { header: "Cease & Desist Letter", text: "In the event that you find an infringing mark, we will provide a Cease and Desist template for you to deliver to your infringing party." },
  { header: "Advanced Search", text: "A comprehensive search including federal and state directories is completed before your mark is filed to ensure there are no conflicts." },
];

const DeluxeBox2 = ({ selected, onChange, price }) => {
  return (
    <div className={"package-box2 " + (selected ? "selected" : null)} style={{verticalAlign: "top"}}>
        <h4>
          <span className="left"></span>
          <span className="left"></span>
          <span className="left"></span>most popular
          <span className="right"></span>
          <span className="right"></span>
          <span className="right"></span>
        </h4>

        <div className="content">
          <h5>Deluxe</h5>
          <div className="price">${price}</div>
          <p style={{color: "#B8B8B8", fontSize: "12px"}}>+ USPTO fees</p>
          <a onClick={() => onChange("DELUXE")}><div className="getstarted-btn">Choose Package</div></a>
          <hr />
          {items ? items.map((item, j) => (
            <Accordion className="feature" key={"Accordion" + j} elevation={0}>
              <AccordionSummary key={"AccordionSummary" + j}
                                aria-controls={"panel-content" + j}
                                id={"panel-header" + j}
              >
                <Typography style={{ color: "#7B848D", fontSize: "14px", width: "100%" }}>{item.header}</Typography>
                <CheckCircleOutlineIcon style={{ float: "right", marginRight: "10px", color: "#7B848D" }} />
              </AccordionSummary>
              <AccordionDetails key={"AccordionDetails" + j}>{item.text}</AccordionDetails>
            </Accordion>
          )) : null}
          <a onClick={() => onChange("DELUXE")}><div className="getstarted-btn" style={{marginTop: "20px", marginBottom: "10px"}} >Choose Package</div>      </a>
        </div>
    </div>
  );
};

export default DeluxeBox2;
